/**
 * 一卡通 TWQR（單筆）付完導回。
 *
 * 付款頁打 pay-link/intents（method_type=ipass_twqr）拿到 payment_url 後把客戶導去 iPASS MONEY；
 * 付完一卡通用 GET 導回我們給的 returnUrl（/pay/{單號}），並在後面接上 `orderNumber=IPQ…`
 * （規格 V1.4 §四）。付款頁看到這個參數就先打 pay-link/ipass-twqr/confirm 讓後端做 A2，
 * 再照一般流程顯示結果。pt 不在網址上——由 payLink.ts 依單號存在 sessionStorage 的備援供應。
 */
const ORDER_NUMBER_RE = /^IPQ[A-Za-z0-9]{1,16}$/;

/** 從 query 讀一卡通帶回的 orderNumber；不是我們產的 IPQ 格式就當沒有。 */
export const readIpassTwqrReturn = (search: string): string | null => {
  const v = (new URLSearchParams(search).get("orderNumber") ?? "").trim();
  return ORDER_NUMBER_RE.test(v) ? v : null;
};
